// Advent Calendar Components
import HowToPlay from "../components/adventcalendar/HowToPlay";
import Calendar from "../components/adventcalendar/Calendar";
import Sharing from "../components/adventcalendar/Sharing";
import SignIn from "../components/adventcalendar/SignIn";
import Faq from "../components/adventcalendar/Faq";
// import Terms from '../components/adventcalendar/Terms&Conditions'

import Notification from "../components/adventcalendar/Notification";
import { Actions as ADVENTCALENDAR_ACTIONS } from "store/actions/adventCalendarActions";
import { Actions as LOGINACTIONS } from "store/actions/authenticationActions";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import backgroundImage from "../assets/images/adventcalendar/background-repeatable.png";
import backgroundImageLast from "../assets/images/adventcalendar/background-repeatable.jpg";
import mbackgroundImage from "../assets/images/adventcalendar/middle-repeatable-background.png";
import topbackgroundImage from "../assets/images/adventcalendar/top-background.jpg";
import bottombackgroundImage from "../assets/images/adventcalendar/bottom-background.jpg";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import sixteenLogo from "../assets/images/sixteen.png";
import myokaLogo from "../assets/images/myoka.png";
import skySpiritLogo from "../assets/images/sky-spirit.png";
import TermsAndConditions from "components/adventcalendar/TermsAndConditions";
import SignInModal from "components/adventcalendar/SignInModal";

import "components/adventcalendar/styles.css";
import LoginRegister from "../components/adventcalendar/LoginRegister";

function AdventCalendar({
							addNotification,
							loggedIn,
							logout,
							processing,
							getMyGifts,
							lastGifted,
							getRecentGifts,
							getTermsModal,
							profile,
							openSignInModal,
						}) {
	const [notificationsTriggered, setNotificationsTriggered] = useState(false);

	useEffect(() => {
		if (lastGifted?.length && !notificationsTriggered) {
			setNotificationsTriggered(true);
			setInterval(() => {
				const lastGiftedToUse = () => {
					const shuffled = lastGifted.sort(() => 0.5 - Math.random());
					return shuffled.slice(0, 2);
				};
				addNotification(lastGiftedToUse()[0], 5000);
			}, 10000);
		}
	}, [lastGifted]);

	useEffect(() => {
		if (!lastGifted) getRecentGifts(2023);

		setTimeout(() => {
			// set the height of the page...
			let width = document.getElementsByTagName('main')[0].clientWidth
			let height = document.getElementsByTagName('main')[0].clientHeight
			let repeatHeight = 656 * width / 1024
			let fullRepeats = Math.ceil(height / repeatHeight)
			let fullHeight = fullRepeats * repeatHeight
			document.getElementsByTagName('main')[0].style.height = fullHeight + 'px'
		},500)

	}, []);

	useEffect(() => {
		if (loggedIn) {
			getMyGifts(2023);
		}
	}, [loggedIn]);

	return (
		<React.Fragment >
			<Helmet>
				<title>Buddy's Advent Calendar</title>
				<meta
					name="description"
					content=""
				/>
				<link
					rel="canonical"
					href={`https://www.buddy.hr/advent-calendar`}
				/>
			</Helmet>
			<div
				className="relative"
				style={{
					backgroundImage: `url(${topbackgroundImage})`,
					width: "100%",
					backgroundSize: "100%",
					backgroundRepeat: "no-repeat no-repeat",
					aspectRatio: "1024/321",
				}}
			>
				{loggedIn && (
					<div className="mx-auto max-w-screen-xl text-right pt-10 md:pt-14 px-6">
						<div className="font-advent christmasButtonLoggedIn w-40 text-lg sm:w-60 text-center inline-block">
							Hi, {profile.givenName || profile.name}
						</div>

						<div
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								logout();
							}}
							className="font-advent text-lg text-right py-3 text-black block drop-shadow-[0_35px_35px_rgba(255,255,255, 0.9)]"
						>
							Sign Out
							{processing && (
								<span className="ml-4">
									<svg
										className="text-orange-600 inline-block animate-spin -ml-1 mr-3 h-5 w-5 text-white"
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 24 24"
									>
										<circle
											className="opacity-25"
											cx="12"
											cy="12"
											r="10"
											stroke="currentColor"
											strokeWidth="4"
										></circle>
										<path
											className="opacity-75"
											fill="currentColor"
											d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
										></path>
									</svg>
								</span>
							)}
						</div>
					</div>
				)}
				{loggedIn ? null : (
					<div className="mx-auto max-w-screen-xl text-right pt-10 md:pt-14 px-6">
						<a className="font-advent christmasButton w-40 text-lg sm:w-60 text-center" onClick={openSignInModal}>Sign In</a>
					</div>
				)}
				<div className='absolute text-center mx-auto min-w-full' style={{bottom: "-50px"}}>
					<h1 className="font-advent text-6xl sm:text-8xl" style={{ color: 'red'}}>Advent Calendar</h1>
					<h6 className="font-advent text-2xl ">play in aid of Food Bank</h6>
				</div>
			</div>
			<div
                style={{
				    backgroundImage: `url(${backgroundImageLast}), url(${backgroundImage})`,
					width: "100%",
					backgroundSize: "100%",
                    backgroundRepeat: "no-repeat no-repeat, no-repeat repeat",
                    backgroundPosition:"center 100%, center 0px",
					aspectRatio: "1024/656",
				}}
			>
				<div className="snowyBackground"></div>
				<main className="mx-auto max-w-screen-xl pt-24 " >
					<HowToPlay />

					<Calendar />

					<Sharing />

					{loggedIn ? null : (
						<div>
							<LoginRegister />
						</div>
					)}

					{/*Partner block*/}
					{/*
					<div className="px-14">
						<p className="text-sm text-gray-900 uppercase tracking-wide font-semibold">Partnered with</p>
						<div className="mt-5 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
							<div className="inline-block sm:flex sm:flex-wrap sm:items-start sm:justify-between">
								<div className="sm:justify-center px-1">
									<img
										className="h-9 sm:h-10"
										src={sixteenLogo}
										alt="Sixteen"
									/>
								</div>
								<div className="sm:justify-center px-1 pt-6 sm:pt-0">
									<img
										className="h-9 sm:h-10"
										src={myokaLogo}
										alt="Myoka Spas"
									/>
								</div>
								<div className="sm:justify-center px-1 pt-4 sm:pt-0">
									<img
										className="h-9 sm:h-10"
										src={skySpiritLogo}
										alt="Sky Spirit"
									/>
								</div>
							</div>
						</div>
					</div>
					*/}
					<Faq />

					<Notification />
				</main>
			</div>

			<div style={{
				backgroundImage: `url(${bottombackgroundImage})`,
				width: "100%",
				backgroundSize: "100%",
				backgroundRepeat: "no-repeat no-repeat",
				aspectRatio: "1024/321",
			}}>
				<div className="flex flex-col items-center w-full h-full">
					<button className="font-bold py-2 px-4 rounded mt-3 ml-5 hover-underline-animation" onClick={getTermsModal} >
						Terms & Conditions
					</button>
				</div>
				<TermsAndConditions />
			</div>
			<SignInModal/>
		</React.Fragment>
	);
}

const mapStateToProps = (state) => {
	return {
		//loggedIn: state.my.profile ? true : false,
		loggedIn: !!state.my.profile?.email,
		profile: state.my.profile,
		lastGifted: state.adventCalendar.lastGifted,
		processing: state.authentication.processing,
	};
};

const mapDispatchToProps = (dispatch) => ({
	addNotification: (notification, removeAfter) =>
		dispatch(ADVENTCALENDAR_ACTIONS.addNotification(notification, removeAfter)),
	getMyGifts: (year) => dispatch(ADVENTCALENDAR_ACTIONS.getMyGifts(year)),
	getRecentGifts: (year) => dispatch(ADVENTCALENDAR_ACTIONS.getRecentGifts(year)),
	logout: () => dispatch(LOGINACTIONS.logout()),
	getTermsModal: () => dispatch(ADVENTCALENDAR_ACTIONS.getTermsModal(true)),
	openSignInModal: () => dispatch(ADVENTCALENDAR_ACTIONS.toggleSignInModal(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdventCalendar);
